import React from 'react';
import {Empty} from "antd";

const NotFound: React.FC = () => (<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />)

export default NotFound
